import "./Popups.scss";
import "react-status-alert/dist/status-alert.css";
import { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { Button } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { StatusAlertService } from "react-status-alert";
import Simplert from "react-simplert";
import { Paginador } from "../../components/paginador/Paginador";


import {
  BannerResponse,
} from "../../interfaces/bannerInterfaces";
import { activarDesactivarpopup, deletePopup, getPopups } from "../../Services/PopupsService";

export const Popups = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);

  const [popups, setpopups] = useState<BannerResponse[]>([]);
  const [cargado, setCargado] = useState<boolean>(false);
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [popupBorrar, setpopupBorrar] = useState<number>(0);

  const getAll = () => {
    getPopups().then((response) => {
      if (response.data && response.data.data) {
        setpopups(response.data.data);
        setCargado(true);
      }
    });
  };

  useEffect(() => {
    getAll();
  }, []);

  const activarDesactivar = (idPopup: number) => {
    activarDesactivarpopup(idPopup)
      .then((result) => {
        getAll();
        StatusAlertService.showSuccess("Actualizado Exitosamente");
      })
      .catch(() => {
        StatusAlertService.showError("Error al actualizar");
      });
  };

  const borrarPopup = async (idPopup: number) => {
    setpopupBorrar(idPopup);
    setMostrarAlerta(true);
  };
  const confirmarBorrarPopup = async () => {
    setMostrarAlerta(false);
    deletePopup(popupBorrar)
      .then((result) => {
        getAll();
        StatusAlertService.showSuccess("Borrado Exitosamente");
      })
      .catch(({ response }) => {
        const { data } = response;
        StatusAlertService.showError(data.meta.message);
      });
  };

  const bannersMostrar = () =>
    popups.filter(
      (element, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea eliminar el popup seleccionado?"
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarPopup()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row>
          <Col className="heading-1">Popups</Col>
        </Row>
        <div className="d-flex flex-row-reverse bd-highlight mb-3">
          <Link to={"/popups/0"}>
            <Button variant="primary" className="float-end">
              Crear nuevo Popup
            </Button>
          </Link>
        </div>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Titulo</th>
              <th>Fecha de publicacion</th>
              <th>Fecha de Cierre</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {popups.length > 0 ? (
              bannersMostrar().map((popup, index) => (
                <tr key={popup.id} className="colorgray2">
                  <td
                    className={
                      index === 0 ? "" : index === popups.length - 1 ? "" : ""
                    }
                  >
                    {popup.titulo}
                  </td>
                  <td>{moment(popup.inicio).format("DD/MM/YYYY hh:mm:ss")}</td>
                  <td>{moment(popup.fin).format("DD/MM/YYYY  hh:mm:ss")}</td>

                  <td>
                    <Form.Check
                      disabled
                      type="switch"
                      label={popup.estatus == "1" ? "Activo" : "Inactivo"}
                      checked={popup.estatus == "1" ? true : false}
                    />
                  </td>
                  <td
                    className={
                      index === 0 ? "" : index === popups.length - 1 ? "" : ""
                    }
                    width="210"
                  >
                    <Button
                      variant="secondary"
                      className="btntable me-2"
                      onClick={() => borrarPopup(popup.id)}
                    >
                      <div className="material-icons">delete</div>
                    </Button>
                    <Link to={"/popups/" + popup.id}>
                      <Button variant="secondary" className="btntable me-2">
                        <div className="material-icons">edit</div>
                      </Button>
                    </Link>

                    <Button
                    
                      variant="secondary"
                      className="btntable"
                      onClick={() => activarDesactivar(popup.id)}
                    >
                      <div className="material-icons">
                        {popup.estatus == "1" ?'visibility_off':'visibility'}
                        
                        </div>
                    </Button>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={5}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={popups.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
